export enum ETypeFooter {
  CLEAR = 1,
  LINE = 2,
  BUTTON = 3,
  AUTH = 4
}
